module.exports = __webpack_public_path__ + "static/media/1023266.d4e2cba2.png";